import * as React from "react";
import { Lightbox, LightboxType } from "../../../../../../react-core/Html/Components/Lightbox";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { SelectArrangementInformationText } from "../../ConvertCappedToFlexiWizard/Resource/Content";

interface IImportantInformationProps extends IProcessComponentProps {}

interface IImportantInformationState {
    showImportantInformationPopUp: boolean;
}

export class ImportantInformation extends ProcessComponent<IImportantInformationProps, IImportantInformationState> {
    constructor(props: any) {
        super(props);
        this.state = { showImportantInformationPopUp: false };
    }

    public render() {
        return (
            <>
                <Alert
                    alertType={AlertType.Warning}
                    message={
                        <>
                            {SelectArrangementInformationText.warningMessageHeading}
                            <br />
                            <br />
                            {SelectArrangementInformationText.warningMessageBody}
                            <br />
                            <br />
                            <a
                                href="javascript:void(0);"
                                className="hyperlink"
                                onClick={() => this.setState({ showImportantInformationPopUp: true })}
                            >
                                Click here to read more
                            </a>
                        </>
                    }
                />
                {this.state.showImportantInformationPopUp && (
                    <Lightbox
                        show={this.state.showImportantInformationPopUp}
                        title={"Placeholder"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showImportantInformationPopUp: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <p>{SelectArrangementInformationText.popUpMessage}</p>
                        <button
                            className="btn primary"
                            onClick={() => this.setState({ showImportantInformationPopUp: false })}
                        >
                            Close
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
